import React, { useState } from 'react';

import { CreditTransferResponse } from 'us-web-services';
import { StepOneSummary } from './StepOneSummary';
import { StepTwoDetails } from './StepTwoDetails';

export interface Props {
  partner: string;
  partnerLogo: string;
  creditBalance: number;
  creditsTransferred: number;
  successfulTransferInitialValue: boolean;
  transferCredits(partner: string, amount: number): Promise<CreditTransferResponse>;
  trackingCallback(event: string, params?: Record<string, unknown>): Promise<void>;
}

export const PartnerWithCredits = ({
  partner,
  partnerLogo,
  creditBalance,
  creditsTransferred,
  successfulTransferInitialValue,
  transferCredits,
  trackingCallback,
}: Props): JSX.Element => {
  const [showDetails, setShowDetails] = useState<boolean>(successfulTransferInitialValue);
  const [successfulTransfer, setSuccessfulTransfer] = useState<boolean>(successfulTransferInitialValue);

  return (
    <div className='bg-transparent pt-4 pb-4 w-full md:max-w-[360px] text-base'>
      {!showDetails && (
        <StepOneSummary
          partner={partner}
          partnerLogo={partnerLogo}
          creditBalance={creditBalance}
          creditsTransferred={creditsTransferred}
          setShowDetails={setShowDetails}
          setSuccessfulTransfer={setSuccessfulTransfer}
          trackingCallback={trackingCallback}
        />
      )}
      {showDetails && (
        <StepTwoDetails
          partner={partner}
          partnerLogo={partnerLogo}
          creditBalance={creditBalance}
          setShowDetails={setShowDetails}
          successfulTransfer={successfulTransfer}
          transferCredits={transferCredits}
          trackingCallback={trackingCallback}
        />
      )}
    </div>
  );
};
